var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-provider", {
    ref: "validationProvider",
    staticClass: "_eui-form_radiogrupp_validation-provider",
    attrs: {
      tag: "div",
      mode: "eagerMedBlurOchDebounce",
      rules: _vm.vpValidationRules
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var valid = ref.valid
          var errors = ref.errors
          var failedRules = ref.failedRules
          var flags = ref.flags
          return [
            _c(
              "div",
              {
                staticClass: "_eui-form_radiogrupp",
                class: [
                  _vm.vpClass,
                  {
                    "-obligatorisk": _vm.skaMarkerasSomObligatorisk,
                    "-readonly": _vm.vpReadOnly,
                    "-osynlig": _vm.skaVaraOsynlig,
                    "-invalid": flags.validated && !valid
                  }
                ],
                style: _vm.vpStyle,
                attrs: { disabled: _vm.skaVaraInaktiverad }
              },
              [
                _vm.vpEtikett
                  ? _c("div", {
                      staticClass: "_eui-form_radiogrupp_etikett",
                      class: {
                        "-readonly": _vm.vpReadOnly
                      },
                      attrs: { title: _vm.vpTooltip },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.vpEtikett +
                            (_vm.vpEtikett.endsWith("?") ? "" : ":")
                        )
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.vpRadiogruppConfig.alternativ, function(
                  alt,
                  altIndex
                ) {
                  return _c(
                    "div",
                    {
                      key: altIndex,
                      staticClass: "_eui-form_radioknapp",
                      class: { "-indragen": _vm.vpEtikett }
                    },
                    [
                      _c(
                        "input",
                        _vm._g(
                          _vm._b(
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.innerValue,
                                  expression: "innerValue"
                                }
                              ],
                              ref: "inputelementArray",
                              refInFor: true,
                              class: {
                                "-readonly": _vm.vpReadOnly
                              },
                              attrs: {
                                id: _vm.altUniktId(altIndex),
                                type: "radio",
                                name: _vm.uniktId + "-name",
                                autofocus: _vm.vpAutofocus && altIndex === 0,
                                disabled:
                                  alt.disabled ||
                                  _vm.skaVaraInaktiverad ||
                                  _vm.vpReadOnly
                              },
                              domProps: {
                                value: alt.varde,
                                checked: _vm.innerValue === alt.varde,
                                checked: _vm._q(_vm.innerValue, alt.varde)
                              },
                              on: {
                                keydown: [
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.onEnterTryckt()
                                  },
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "esc",
                                        27,
                                        $event.key,
                                        ["Esc", "Escape"]
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.onEscTryckt()
                                  }
                                ],
                                change: function($event) {
                                  _vm.innerValue = alt.varde
                                }
                              }
                            },
                            "input",
                            _vm.$attrs,
                            false
                          ),
                          _vm.inputListeners
                        )
                      ),
                      _vm._v(" "),
                      _c("label", {
                        staticClass: "_eui-form_radioknapp_etikett",
                        class: {
                          "-readonly": _vm.vpReadOnly
                        },
                        attrs: { for: _vm.altUniktId(altIndex) },
                        domProps: { innerHTML: _vm._s(alt.text + "&nbsp;") }
                      })
                    ]
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "_eui-form_radiogrupp_feltext" }, [
                  _c("div", {
                    staticClass: "ellipsis",
                    domProps: { innerHTML: _vm._s(errors[0]) }
                  })
                ])
              ],
              2
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }